<template>
  <section class="previewContainer" :id="linkPreview.id">
    <div class="previewTextContainer">
      <b class="previewTitle">{{ linkPreview.title }}</b>
      <p style="text-overflow: ellipses">{{ url }}</p>
    </div>
    <img class="previewImage" :src="linkPreview.images[0]" />
  </section>
</template>

<script>
export default {
  props: ["linkPreview"],

  components: {},

  data: () => ({
    url: "",
  }),

  mounted() {
    const index = this.linkPreview.url.indexOf("/", 8);
    this.url = this.linkPreview.url.substring(8, index);
  },

  watch: {},

  computed: {},

  methods: {},
};
</script>

<style scoped>
.previewContainer {
  display: flex;
  flex-direction: row;
  width: max-content;
  max-width: 300px;
  height: 100px;
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 10px;
  justify-content: flex-start;
  text-overflow: ellipsis;
  overflow: hidden;
}
.previewImage {
  width: 100px;
  height: auto;
  max-height: 80px;
}
.previewTextContainer {
  display: flex;
  flex-direction: column;
  text-overflow: ellipsis;
  overflow: hidden;
}
.previewTitle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 80%;
}
</style>
